import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import { useParams, useNavigate, Link } from "react-router-dom";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const VehDetview = () => {
  useAuthRedirect();
  const { id } = useParams();
  const navigate = useNavigate();
  const userName = localStorage.getItem("username");
  const [selectedBranch] = useState(localStorage.getItem("branch") || "");

  // Initialize formData with all needed fields.
  const [formData, setFormData] = useState({
    fld_vehiclecode: "",
    fld_soldorscrap: "",
    fld_soldscrap_by: "",
    fld_soldscrap_approved: "",
    fld_soldprice: "",
    fld_remarks: "",
    fld_soldscrap_date: "",
    fld_soldscrap_from: "",
    fld_partyname: "",
    fld_broker: "",
    // Optionally include additional fields if required:
    fld_date: "",
    branch_code: "",
    LogId: ""
  });

  const canView  = hasPermission("Vehicle Scrap Report", "view");

  useEffect(() => {
    const fetchVehicleData = async () => {
      try {
        const response = await axios.get(
          `https://rfs2.infraconsoft.net.in/api/get_veh_sale_scrap_api/${id}`
        );
        
        const data = response.data[0]; // Access first item from array
        // console.log("Fetched data:", data);
  
        // Set form data
        setFormData({
          fld_date: data.fld_soldscrap_date?.split("T")[0] || "",
          branch_code: data.branchcode?.trim() || "",
          LogId: userName,
          fld_vehiclecode: data.fld_vehiclecode || "",
          fld_soldorscrap: data.fld_soldorscrap || "",
          fld_soldscrap_by: data.fld_soldscrap_by || "",
          fld_soldscrap_approved: data.fld_soldscrap_approved || "",
          fld_soldprice: data.fld_soldprice || "",
          fld_remarks: data.fld_remarks || "",
          fld_soldscrap_date: data.fld_soldscrap_date?.split("T")[0] || "",
          fld_soldscrap_from: data.fld_soldscrap_from?.trim() || "",
          fld_partyname: data.fld_partyname || "",
          fld_broker: data.fld_broker || "",
        });
      } catch (error) {
        console.error("Error fetching vehicle record:", error);
      }
    };
  
    fetchVehicleData();
  }, [id, userName]);
  
  // Although you have a handleChange, it isn't currently used since you're only displaying values.
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

      if (!canView) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }


  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          
            <div className="back-div">
            <h2 className="add-txt">Vehicle Sold & Scrap - View</h2>
            <Link to={`/vehicle_soldscrab_report`}><p className="back-button"><i className="fa-solid fa-backward"></i> Back</p></Link>
            </div>
          <Time />
        </section>
        <div className="form-container">
          <form className="vehicle-form">

          <div className="form-row">
              <div className="form-group">
                <label>Vehicle Code :</label>
                <input type="text" name="fld_vehiclecode" value={formData.fld_vehiclecode} readOnly/>
              </div>
              <div className="form-group">
                <label>Entry Date :</label>
                <input type="text" name="fld_soldscrap_date" value={formData.fld_soldscrap_date} readOnly/>
              </div>
            </div>

            <div className="form-row">
              
              <div className="form-group">
                <label>Sold & Scrap :</label>
                <input type="text" name="fld_soldorscrap" value={formData.fld_soldorscrap} readOnly  />
              </div>
              <div className="form-group">
                <label>Scrap & Sold from Branch :</label>
                <input type="text" name="fld_soldscrap_from" value={formData.fld_soldscrap_from} readOnly  />
              </div>
            </div>

{formData.fld_soldorscrap === "scrap" ? (
  <div className="form-row">
    <div className="form-group">
      <label>Scrapped By :</label>
      <input
        type="text"
        name="fld_soldscrap_by"
        value={formData.fld_soldscrap_by}
        readOnly
      />
    </div>

    <div className="form-group">
      <label>Scrap Approved By :</label>
      <input
        type="text"
        name="fld_soldscrap_approved"
        value={formData.fld_soldscrap_approved}
        readOnly
      />
    </div>
  </div>
) : (
  <div className="form-row">
    <div className="form-group">
      <label>Party Name :</label>
      <input
        type="text"
        name="fld_partyname"
        value={formData.fld_partyname}
        readOnly
      />
    </div>
    <div className="form-group">
      <label>Broker :</label>
      <input
        type="text"
        name="fld_broker"
        value={formData.fld_broker}
        readOnly
      />
    </div>
  </div>
)}
            

         
{formData.fld_soldorscrap === "scrap" ? (
   <div className="form-row">
              <div className="form-group">
                <label>Remarks :</label>
                <input type="text" name="fld_remarks" value={formData.fld_remarks} readOnly  />
              </div>
              <div className="form-group">
                <label></label>
                <input type="hidden"  />
              </div>
            </div>

            
            ) : (
              <div className="form-row">
              <div className="form-group">
                <label>Sold Price :</label>
                <input type="text" name="fld_soldprice" value={formData.fld_soldprice} readOnly  />
              </div>
              <div className="form-group">
                <label>Remarks :</label>
                <input type="text" name="fld_remarks" value={formData.fld_remarks} readOnly  />
              </div>
            </div>
            )}


          </form>
        </div>
      </div>
    </div>
  );
};

export default VehDetview;
